import { createAction } from 'redux-actions'

const prefix = 'PERSONAL_SETTINGS/'

export const uiSetPreviewUrl = createAction(`${prefix}UI_SET_PREVIEW_URL`)
export const uiSetUserImage = createAction(`${prefix}UI_SET_USER_IMAGE`)
